var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages-search"},[(_vm.detailShow)?_c('div',{staticClass:"resource-detail-block"},[_c('resource-detail',{attrs:{"show":_vm.detailShow,"detailData":_vm.detailData,"detailType":"2","isSearch":"","origin":_vm.origin},on:{"onReturn":function($event){_vm.detailShow = false}}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }